export const primaryStyle = {
  backgroundColor: "rgb(98, 100, 167)",
  ":hover": {
    backgroundColor: "rgb(122, 128, 235)",
  },
};
